// Liao 2.0 cart drawer promo code.
// Applies a discount code via Shopify's discount URL (sets the checkout
// cookie), remembers it in sessionStorage, and shows an "applied at
// checkout" chip. Delegated listeners survive the drawer's innerHTML
// re-renders (cart.js swaps #mini-cart content on every cart change).
(function () {
  var KEY = 'liao-promo-code';

  function syncPromoUI(root) {
    var promo = root.querySelector('[data-liao-promo]');
    if (!promo) return;
    var code = null;
    try {
      code = window.sessionStorage.getItem(KEY);
    } catch (e) {}
    var field = promo.querySelector('[data-liao-promo-field]');
    var applied = promo.querySelector('[data-liao-promo-applied]');
    if (code) {
      field.hidden = true;
      applied.hidden = false;
      applied.querySelector('[data-liao-promo-code]').textContent = code;
    } else {
      field.hidden = false;
      applied.hidden = true;
    }
  }

  function applyCode(promo) {
    var input = promo.querySelector('[data-liao-promo-input]');
    var code = (input.value || '').trim();
    if (!code) return;
    fetch('/discount/' + encodeURIComponent(code))
      .then(function () {
        try {
          window.sessionStorage.setItem(KEY, code.toUpperCase());
        } catch (e) {}
        syncPromoUI(document);
      })
      .catch(function (e) {
        console.error('Liao promo apply failed', e);
      });
  }

  document.addEventListener('click', function (event) {
    var apply = event.target.closest('[data-liao-promo-apply]');
    if (apply) {
      applyCode(apply.closest('[data-liao-promo]'));
      return;
    }
    var remove = event.target.closest('[data-liao-promo-remove]');
    if (remove) {
      try {
        window.sessionStorage.removeItem(KEY);
      } catch (e) {}
      syncPromoUI(document);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest('[data-liao-promo-input]');
    if (!input) return;
    event.preventDefault();
    applyCode(input.closest('[data-liao-promo]'));
  });

  document.addEventListener('cartdrawer:opened', function () {
    syncPromoUI(document);
  });
  document.addEventListener('cart:updated', function () {
    // drawer content was just re-rendered
    setTimeout(function () {
      syncPromoUI(document);
    }, 0);
  });
  document.addEventListener('DOMContentLoaded', function () {
    syncPromoUI(document);
  });
})();

// Cart drawer plan dropdown and Root & Soothe swap (2026-10-27).
// Both re-render the drawer from the Section Rendering API response the
// same way cart.js does, then fire cart:updated so the promo chip syncs.
(function () {
  var SECTIONS = ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json();
    });
  }

  function render(state) {
    if (window.location.pathname.indexOf('/cart') === 0) {
      window.location.reload();
      return;
    }
    SECTIONS.forEach(function (id) {
      var el = document.getElementById(id);
      var html = state.sections && state.sections[id];
      if (!el || !html) return;
      var target = el.querySelector('.shopify-section') || el;
      var parsed = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      target.innerHTML = parsed ? parsed.innerHTML : html;
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: state } }));
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'liao-cart' });
    }
  }

  function busy(on) {
    var cart = document.querySelector('.liao-cart');
    if (cart) cart.classList.toggle('is-busy', on);
  }

  function fail(e) {
    busy(false);
    console.error('Liao cart update failed', e);
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-liao-plan]');
    if (!select) return;
    busy(true);
    post('/cart/change.js', {
      line: Number(select.dataset.line),
      quantity: Number(select.dataset.quantity),
      selling_plan: select.value ? Number(select.value) : null,
      sections: SECTIONS,
      sections_url: window.location.pathname
    })
      .then(render)
      .catch(fail);
  });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-liao-swap]');
    if (!btn) return;
    btn.disabled = true;
    busy(true);
    var item = { id: Number(btn.dataset.variant), quantity: Number(btn.dataset.quantity) };
    if (btn.dataset.plan) item.selling_plan = Number(btn.dataset.plan);
    post('/cart/change.js', { line: Number(btn.dataset.line), quantity: 0 })
      .then(function () {
        return post('/cart/add.js', {
          items: [item],
          sections: SECTIONS,
          sections_url: window.location.pathname
        });
      })
      .then(render)
      .catch(fail);
  });
})();
